enum HandlingEquipmentsEnum {
  FORKLIFT = 'FORKLIFT',
  DOLLY = 'DOLLY',
  NONE = 'NONE',
}

export default HandlingEquipmentsEnum;
